import React from 'react';
import { Box } from 'grommet';
import { useHistory, useParams } from 'react-router-dom';
import SHDButton from '@ui/Button/SHDButton';
import SHDHeading from '@ui/Heading/SHDHeading';
import SHDText from '@ui/Text/SHDText';
import SHDThemeOverride from '@ui/ThemeOverride/SHDThemeOverride';
import withLayout from '@helpers/withLayout';

const YouStruckoutError: React.FC = () => {
  const { errorStatus } = useParams<{
    errorStatus: string;
  }>();
  const history = useHistory();
  const searchParams = new URLSearchParams(location.search);
  const handle = searchParams.get('handle');
  let displayError = '';
  if (errorStatus === '404') {
    displayError = `The team or player with id ${handle} could not be found.`;
  }

  return (
    <SHDThemeOverride full={false} background="background">
      <Box
        align="center"
        justify="center"
        gap="xxlarge"
        margin={{ top: 'xxlarge' }}
      >
        <Box gap="xxsmall" align="center">
          <SHDHeading level={3}>You struck out!</SHDHeading>

          <Box gap="xxxsmall">
            {displayError && (
              <SHDText
                color="gray-900-alpha-80"
                style="subhead"
                textAlign="center"
              >
                {displayError}
              </SHDText>
            )}

            <SHDText
              color="gray-900-alpha-80"
              style="subhead"
              textAlign="center"
            >
              Please make sure that your link is correct.
            </SHDText>
          </Box>
        </Box>

        <Box align="center">
          <SHDButton primary onClick={() => history.push('/home')}>
            Go home
          </SHDButton>
        </Box>
      </Box>
    </SHDThemeOverride>
  );
};
export default withLayout(YouStruckoutError);
